import * as _4 from 'lodash4';
import { Query } from 'utility-ts-orm';
import { IQuery } from 'core-ts-types';
import { RegistrationPinsPermissionModel } from '../models/registration_pins_permission_model';
import { SchedulerCustomTextQuery } from '../../course_scheduler/queries/scheduler_custom_text_query';
import { TermPinServant } from '../../../components/term_pin/servants/term_pin_servant';

interface IRegistrationPinsPermissionQueryResult {
  showSectionsPinsDialog: boolean;
  sectionPinText: string;
  isPermissionPinsFeatureEnabled: boolean;
  isTermPinFeatureEnabled: boolean;
}

export class RegistrationPinsPermissionQuery implements IQuery {
  private _result: IRegistrationPinsPermissionQueryResult;

  constructor(
    private ngRegistrationPinsPermissionModel: RegistrationPinsPermissionModel,
    private ngSchedulerCustomTextQuery: SchedulerCustomTextQuery,
    private appConfigModel: any,
    private ngTermPinServant: TermPinServant
  ) {
    Query.registerQuery(this, ngRegistrationPinsPermissionModel);
  }

  run() {
    this._result = {
      showSectionsPinsDialog: this.ngRegistrationPinsPermissionModel.read().showSectionsPinsDialog,
      sectionPinText: this.ngSchedulerCustomTextQuery.result.SECTION_PIN_TEXT,
      isPermissionPinsFeatureEnabled: this.appConfigModel.model.member_features['reg-class_permission'],
      isTermPinFeatureEnabled: this.ngTermPinServant.isTermPinFeatureEnabled()
    };
    return this;
  }

  get result() {
    return this._result;
  }
}

angular.module('capability-ng-scheduler').service('ngRegistrationPinsPermissionQuery', RegistrationPinsPermissionQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/registration/queries/registration_pins_permission_query.ts